import { IEntityDataService } from "@pit/core-data";
import { IDtoShipmentProcess, ProductionSystemTransferState } from "@pit/frontend-model";
import { Observable } from "rxjs";

export interface IDtoShipmentProcessEntityDataService extends IEntityDataService<IDtoShipmentProcess> {

    getActiveShipmentProcessesForDepot$(depotNumber: string): Observable<IDtoShipmentProcess[]>;
    getActiveShipmentProcessesForDepotAsync(depotNumber: string): Promise<IDtoShipmentProcess[]>;

    getShipmentProcessesToReturnForDepot$(depotNumber: string, includeInDelivery?: boolean): Observable<IDtoShipmentProcess[]>;
    getShipmentProcessesToReturnForDepotAsync(depotNumber: string, includeInDelivery?: boolean): Promise<IDtoShipmentProcess[]>;

    setShipmentProcess$(shipmentProcess: IDtoShipmentProcess): Observable<IDtoShipmentProcess>;
    setShipmentProcessAsync(shipmentProcess: IDtoShipmentProcess): Promise<IDtoShipmentProcess>;

    setShipmentProcesses$(shipmentProcesses: IDtoShipmentProcess[]): Observable<IDtoShipmentProcess[]>;
    setShipmentProcessesAsync(shipmentProcesses: IDtoShipmentProcess[]): Promise<IDtoShipmentProcess[]>;

    getShipmentProcessesForMandatorByProductionSystemTransferState$(mandator: string, transferState: ProductionSystemTransferState): Observable<IDtoShipmentProcess[]>;
    getShipmentProcessesForMandatorByProductionSystemTransferStateAsync(mandator: string, transferState: ProductionSystemTransferState): Promise<IDtoShipmentProcess[]>;

    getShipmentProcessesByProductionSystemTransferStateForDepot$(transferState: ProductionSystemTransferState, depotNumber: string): Observable<IDtoShipmentProcess[]>;
    getShipmentProcessesByProductionSystemTransferStateForDepotAsync(transferState: ProductionSystemTransferState, depotNumber: string): Promise<IDtoShipmentProcess[]>;

}
